<template>
  <div class="relative flex items-start">
    <div class="flex items-center h-5">
      <input v-model="check" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
    </div>
    <div class="ml-3 text-sm">
      <label for="comments" class="font-medium text-gray-700">{{ title }}</label>
      <p id="comments-description" class="text-gray-500">{{ description }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['config', 'title', 'description', 'id', 'blockId', 'role'],
  data() {
    return {
      check: this.config && this.config[this.id] || "",
    }
  },
  watch: {
    check() {
      const config = { ...this.config }
      config[this.id] = this.check

      console.warn("setBlockConfig: ", "check")
      this.$store.dispatch('editor/setBlockConfig', {
        id: this.blockId,
        role: this.role,
        config: config,
      })
    },
  }
}

</script>
